module.exports = __webpack_public_path__ + "img/banner.b716c758.jpg";